export default __webpack_public_path__ + "static/media/terminal.1f9e7c36.svg";